module.exports = __webpack_public_path__ + "img/u771.a2cef53e.jpg";